const concatStyles = (...args) => {
    return args.filter(Boolean).join(' ');
};

export { concatStyles as c };
